import PropTypes from 'prop-types';
import React from 'react';
import { ClipLoader } from 'react-spinners';
import Styled from './loader-component-style';

/**
 * @param {object} props - The root element
 * @param {boolean} props.loading - The loading state
 * @param {number} props.size - The size of the loader
 * @param {boolean} props.card - To show a card or not around the loader
 * @param {string} props.margin - margin
 * @returns {JSX.Element} - ClipLoader
 */
const Loader = ({ loading, size, card, margin, ...props }) =>
  loading && (
    <Styled.Container $margin={margin} {...props}>
      <Styled.Card $card={card}>
        <ClipLoader loading={loading} size={size} />
      </Styled.Card>
    </Styled.Container>
  );

Loader.defaultProps = {
  loading: false,
  size: 50,
  card: false,
  margin: '20px',
};

Loader.propTypes = {
  loading: PropTypes.bool,
  size: PropTypes.number,
  card: PropTypes.bool,
  margin: PropTypes.string,
};

export default Loader;
